import { fmtDay } from "./Period";

const ITEMS = [
  ["total_participants", "Total de participantes cadastrados"],
  ["new_participants", "Novos participantes"],
  ["messages", "Mensagens recebidas"],
  ["oracao", "Pedidos de oração"],
  ["fotografia", "Fotografias recebidas"],
  ["testemunho", "Testemunhos recebidos"],
  ["comprovante", "Comprovantes Pix recebidos"],
  ["deus_provera", "Solicitações Deus Proverá"],
  ["pending", "Atendimentos pendentes"],
  ["answered", "Atendimentos respondidos"],
];

const Daily = ({ days }) => {
  const max = Math.max(1, ...days.map((d) => d.count));
  return (
    <section className="space-y-3">
      <h2 className="font-display text-base font-semibold">Mensagens recebidas por dia</h2>
      {days.length === 0 ? <p className="text-sm text-muted-foreground">Sem mensagens no período.</p> : (
        <div data-testid="reports-by-day" className="flex h-36 items-end gap-1 border-b border-zap-line">
          {days.map((d) => (
            <div key={d.day} title={`${fmtDay(d.day)}: ${d.count}`} className="flex-1 rounded-t-sm bg-zap-green/80"
              style={{ height: `${(d.count / max) * 100}%`, maxWidth: 28 }} />
          ))}
        </div>
      )}
    </section>
  );
};

export const Figures = ({ r }) => (
  <div className="space-y-10">
    <dl data-testid="reports-figures" className="grid grid-cols-2 border-y border-zap-line sm:grid-cols-3 lg:grid-cols-5">
      {ITEMS.map(([k, label]) => (
        <div key={k} data-testid={`figure-${k}`} className="border-b border-zap-line px-3 py-4 last:border-b-0">
          <dt className="text-xs leading-snug text-muted-foreground">{label}</dt>
          <dd className="font-display text-2xl font-semibold tabular-nums text-zap-ink">{r.figures[k]}</dd>
        </div>
      ))}
    </dl>
    <p className="text-xs text-muted-foreground">
      Total de cadastrados considera todos até {fmtDay(r.end)}. Os demais números contam só o período. Atendimentos contam os abertos no período, pela situação atual.
    </p>
    <Daily days={r.by_day} />
  </div>
);
